// RiskManagementContext.tsx
import React, {
  createContext,
  useContext,
  useState,
  PropsWithChildren,
} from "react";
import { RiskManagementplanList } from "../../pages/RiskManagement/modal";

// Define the interface for context values
interface IncidentResponsePlanContextType {
  selectedIRPTestPreview: any;
  setSelectedIRPTestPreview: React.Dispatch<React.SetStateAction<any>>;

  IRPTestDetails: any;
  setIRPTestDetails: React.Dispatch<React.SetStateAction<any>>;

  isFileRefresh: boolean;
  setIsFileRefresh: React.Dispatch<React.SetStateAction<boolean>>;

  selectedIncidentResponsePlan: any;
  setSelectedIncidentResponsePlan: React.Dispatch<React.SetStateAction<any>>;
  planDetails: any;
  setPlanDetails: React.Dispatch<React.SetStateAction<any>>;
}

// Create context with initial values
const IncidentResponsePlanContext = createContext<
  IncidentResponsePlanContextType | undefined
>(undefined);

// Create a provider component to wrap your app
export const IncidentResponsePlanProvider = ({
  children,
}: PropsWithChildren<{}>) => {
  const [selectedIRPTestPreview, setSelectedIRPTestPreview] = useState<any>();
  const [selectedIncidentResponsePlan, setSelectedIncidentResponsePlan] =
    useState<any>({});
  const [planDetails, setPlanDetails] = useState<any>({});
  const [isFileRefresh, setIsFileRefresh] = useState<boolean>(false);
  const [IRPTestDetails, setIRPTestDetails] = useState<any>({});

  return (
    <IncidentResponsePlanContext.Provider
      value={{
        selectedIRPTestPreview,
        setSelectedIRPTestPreview,
        selectedIncidentResponsePlan,
        setSelectedIncidentResponsePlan,
        planDetails,
        setPlanDetails,
        isFileRefresh,
        setIsFileRefresh,
        IRPTestDetails,
        setIRPTestDetails,
      }}
    >
      {children}
    </IncidentResponsePlanContext.Provider>
  );
};

// Create a custom hook for using IncidentResponsePlanContext
export const useIncidentResponsePlanContext = () => {
  const context = useContext(IncidentResponsePlanContext);
  if (!context) {
    throw new Error(
      "useIncidentResponsePlanContext must be used within a IncidentResponsePlanProvider"
    );
  }
  return context;
};

export default IncidentResponsePlanContext;
